import { createApp } from '@app/adapters/create-app'

import WorkflowProgress from '@app/application/workflows/screens/workflow-review/components/workflow-progress'

const initWorkflowCompletion = () => {
  document
    .querySelectorAll("[data-behaviour='workflow-completion']")
    .forEach((el) => {
      const data = el.dataset

      const isLocked = data.isLocked === 'true'
      const showLegend = data.showLegend === 'true'

      createApp(WorkflowProgress, {
        color: isLocked ? 'text' : 'primary',
        disabled: isLocked,
        lastId: parseInt(data.lastId),
        ledgerId: parseInt(data.ledgerId),
        showLegend,
        showTotalPercentage: true,
        size: 'medium',
        workflowId: parseInt(data.workflowId),
      }).mount(el)
    })
}

onDomLoad(() => {
  // WF progress is displayed both in the async-rendered ledger_table (CWF#show), but also in the server-side rendered CWF#index
  // thus, we need to initialize both on DOM load, as well as on render_async_load
  initWorkflowCompletion()

  document.addEventListener('render_async_load', initWorkflowCompletion)

  document.addEventListener(
    'turbolinks:visit',
    () => {
      document.removeEventListener('render_async_load', initWorkflowCompletion)
    },
    { once: true }
  )
})
